export default [
  {
    name: 'Vapormax Plus',
    color: 'black',
  },
  {
    name: 'Vapormax',
    color: 'asphalt',
  },
  {
    name: 'Vapormax',
    color: 'Grape',
  },
  {
    name: 'AirMax',
    color: 'Leopard',
  },
  {
    name: 'AirMax',
    color: 'wheat',
  },
  {
    name: 'Flyknit',
    color: 'zebra',
  },
  {
    name: 'Air Max 270',
    color: 'React camo',
  },
  {
    name: 'Airmax 90',
    color: 'Galaxy',
  },
  {
    name: 'Airmax 270',
    color: 'Black Gold',
  },
]
